export type PurchasingModuleDef = {
  slug: string;
  label: string;
  icon: string;
  title: string;
  description: string;
  /** Hidden from bottom nav for now (route may still exist). */
  navHidden?: boolean;
};

/** Bottom dock modules for Purchasing portal (extend as features are added). */
export const PURCHASING_MODULES: PurchasingModuleDef[] = [
  {
    slug: 'items',
    label: 'Items',
    icon: '📦',
    title: 'Items',
    description: 'Product catalogue and certificate library (SFA, ISO, Food Grade / MSDS).',
  },
];

export const PURCHASING_MAIN_MODULES = PURCHASING_MODULES.filter((m) => !m.navHidden);
